import { render } from "./App.vue?vue&type=template&id=661f6c3e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=661f6c3e&lang=css"

import exportComponent from "/builds/portal-da-transparencia/cge-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__